import i18n from "@/i18n/i18n";

export function getAll() {
  return [
    {
      value: -1,
      name: "All",
      text: `${i18n.global.t("enums.foodStatusType.All")}`,
    },
    {
      value: 0,
      name: "Normal",
      text: `${i18n.global.t("enums.foodStatusType.Normal")}`,
    },
    {
      value: 1,
      name: "Discontinued",
      text: `${i18n.global.t("enums.foodStatusType.Discontinued")}`,
    },
  ];
}
